import { Alert } from "@minervaproject/fds";

import { PreclassTestResultMessageType } from "../../../shared/types/preclass_check";

const getAlert = (alertInfo: PreclassTestResultMessageType) => {
  if (!alertInfo) {
    return null;
  }
  return (
    <Alert
      className="mb5"
      kind={alertInfo.alertKind}
      showClose={false}
      data-testid="preclass-alert"
    >
      <span className="bold">{alertInfo.message}</span>
      <span>&nbsp;{alertInfo.action}</span>
      {alertInfo.link && (
        <span>
          <a href={alertInfo.link} target="_blank" rel="noopener noreferrer">
            {" "}
            Learn more
          </a>
        </span>
      )}
    </Alert>
  );
};

function PreclassCheckAlert({ preclassAlert }: { preclassAlert: PreclassTestResultMessageType }) {
  return getAlert(preclassAlert);
}

export { PreclassCheckAlert };
